/* RAVIN / Floating Controls — single-open and click-away coordinator.
 * Only the native theme widgets participate: Paper Post, Paper Bag Rivals,
 * and Pulse (Chat/VIP). No event is prevented or stopped.
 */
(() => {
  if (window.__RavinFloatingCoordinator) return;
  window.__RavinFloatingCoordinator = true;

  const widgets = [
    {selector: '[data-ravin-notifications]', isOpen: el => el.dataset.rnMode === 'expanded'},
    {selector: '[data-rv-rivals]', isOpen: el => !el.classList.contains('is-minimized')},
    {selector: '[data-ravin-pulse]', isOpen: el => el.dataset.rpExpanded === 'true'}
  ];
  const closeEvent = 'ravin:float:close';

  function handleInteraction(event) {
    const target = event.target;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const roots = widgets.flatMap(widget => {
      return Array.from(document.querySelectorAll(widget.selector))
        .filter(el => !el.hidden)
        .map(el => ({ el, isOpen: widget.isOpen(el) }));
    });

    // A tap inside a widget keeps that widget open (or allows its own toggle);
    // other expanded widgets close before this tap's original action proceeds.
    const owner = roots.find(item =>
      path.includes(item.el) ||
      (target instanceof Node && item.el.contains(target))
    );

    for (const item of roots) {
      if (item === owner || !item.isOpen) continue;
      item.el.dispatchEvent(new CustomEvent(closeEvent));
    }
  }

  // Capture phase ensures the previous widget minimizes BEFORE the tapped
  // button opens the new one. Standard link and button actions still fire.
  document.addEventListener('pointerdown', handleInteraction, true);

  // Keyboard-generated click events have no pointerdown; make them work too.
  document.addEventListener('click', event => {
    if (event.detail === 0) handleInteraction(event);
  }, true);
})();
